(ns bp-clients.tv-app.utils.utils
  "Namespace for functions used as utilities"
  (:require [bp-clients.tv-app.utils.logger :as logger]
            [clojure.string :as str]))

(def navigation-selectors
  {:content     10
   :menu        20
   :player-side 30
   :overlay     40})

(def delay-to-focus
  "This delay is used to make the best effort to focus in
  a element, after some action.

  It is small enough to look like instantaneous and big
  enough to let elements load properly."
  200)

(defn human-duration
  "Given seconds returns H:M:S human readable format"
  [seconds]
  (let [total-seconds (Math/round seconds)
        hours         (Math/floor (/ total-seconds (* 60 60)))
        minutes       (Math/floor (/ (- total-seconds (* 60 60 hours)) 60))]
    (cond-> ""
      (pos? hours)   (str hours " h ")
      (pos? minutes) (str minutes " m"))))

(defn- zero-leftpad
  "Leftpad a string with zeroes.
  I.e.: (zero-leftpad 5 \"a\") => \"0000a\""
  [n s]
  (let [zeroes (str/join (repeat n "0"))]
    (str (subs zeroes (count s)) s)))

(defn video-duration
  "Given seconds returns H:M:S human readable format"
  [seconds]
  (let [total-seconds (Math/round seconds)
        hours         (Math/floor (/ total-seconds (* 60 60)))
        minutes       (Math/floor (/ (- total-seconds (* 60 60 hours)) 60))
        seconds       (Math/floor (- total-seconds (* minutes 60) (* hours 60 60)))]
    (cond-> ""
      (pos? hours)   (str (zero-leftpad 2 (str hours)) ":")
      true (str (zero-leftpad 2 (str minutes)) ":")
      true (str (zero-leftpad 2 (str seconds))))))

(defn cloudinary-image
  "Given a partial url prepends it with cloudinary service"
  ([url]
   (cloudinary-image url nil))
  ([url size]
   (let [{:keys [width trim?]} size
         w  (when (pos? width) (str ",w_" width))
         t  (when trim? ",e_trim")]
     (when (seq url)
       (str "https://images.brasilparalelo.com.br/hvzbb2hdx/image/upload/c_scale,f_auto" t w "/v1/" url)))))

(defn parse-date
  "Returns a js/Date object. If the passed in argument isn't parseable as date, returns js/NaN"
  [date]
  (new js/Date (.parse js/Date date)))

(defn stop-event-propagation
  [^js/Object js-event]
  (when js-event
    (.preventDefault js-event)
    (.stopPropagation js-event)))

(defn get-year
  "Given a js/Date returns its year or nil"
  [date]
  (let [date? (not (js/isNaN date))]
    (when date?
      (-> date .getFullYear))))

(defn focus-inside?
  [container]
  (if (-> js/self .-document undefined?)
    (logger/warn "focus-inside? should not be called inside a worker")
    (when (and container (= js/Node.ELEMENT_NODE (.-nodeType container)))
      (.contains container js/document.activeElement))))

(defn get-percentage
  "Returns the percentage of value over the total"
  [value total]
  (let [total (max total 1)]
    (int (* (/ value total) 100))))

(defn insensitive-compare
  "Insensitive compare two strings"
  [& strs]
  (apply = (map #(clojure.string/lower-case (or % "")) strs)))
